// Mock data for Pinnacle Biomed India website

export const companyInfo = {
  name: "Pinnacle Biomed India Pvt. Ltd.",
  tagline: "Excellence in Healthcare Infrastructure",
  description: "Turnkey healthcare infrastructure and hospital management company providing end-to-end solutions for Government, Private, and Trust Hospitals/Institutions across India."
};

export const heroData = {
  title: "Excellence in Healthcare Infrastructure",
  subtitle: "Turnkey solutions from conceptualization to commissioning and long-term operations",
  description: "Single-agency responsibility for healthcare projects ensuring compliance with statutory, medical, and health safety standards across India.",
  ctaText: "Request Project Consultation",
  image: "https://images.unsplash.com/photo-1586773860418-d37222d8fce3?w=1600&q=80"
};

export const aboutData = {
  title: "About Pinnacle Biomed",
  description: "Pinnacle Biomed India Pvt. Ltd. is a leading turnkey healthcare infrastructure and hospital management company providing comprehensive end-to-end solutions for Government, Private, and Trust Hospitals/Institutions across India.",
  mission: "We undertake single-agency responsibility for projects from conceptualization to commissioning and long-term operations, ensuring compliance with statutory, medical, and health safety standards.",
  commitment: "Committed to delivering safe, compliant, and sustainable healthcare infrastructure solutions that support public health objectives and clinical excellence.",
  image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1600&q=80"
};

export const servicesData = [
  {
    id: 1,
    title: "Design & Engineering",
    description: "Conceptual planning, feasibility studies, architectural design as per NMC, NABH, ICMR, HTM, NFPA, ISO, IPHS, NBC standards.",
    image: "https://images.unsplash.com/photo-1504439468489-c8920d796a29?w=800&q=80"
  },
  {
    id: 2,
    title: "EPC & Construction",
    description: "Engineering, Procurement & Construction of MEP and modular healthcare infrastructure including Operation Theatres, ICUs, and specialized medical facilities.",
    image: "https://images.unsplash.com/photo-1587351021759-3e566b6af7cc?w=800&q=80"
  },
  {
    id: 3,
    title: "Medical Equipment & IT Systems",
    description: "Complete planning, procurement, and implementation of medical equipment and IT systems for modern healthcare facilities.",
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800&q=80"
  },
  {
    id: 4,
    title: "Operations & Management",
    description: "Hospital operations and management including complete medical, paramedical, technical, administrative, and facility staffing.",
    image: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&q=80"
  }
];

export const projectTypesData = {
  primary: {
    title: "Primary Level Healthcare Facilities",
    description: "Foundation of healthcare delivery system",
    facilities: [
      "Primary Health Centre",
      "Urban Primary Health Centre"
    ],
    image: "https://images.unsplash.com/photo-1632833239869-a37e3a5806d2?w=800&q=80"
  },
  secondary: {
    title: "Secondary Level Healthcare Facilities",
    description: "Intermediate healthcare infrastructure",
    facilities: [
      "Community Health Centre",
      "Sub-District Hospital",
      "District Hospital"
    ],
    image: "https://images.unsplash.com/photo-1586773860418-d37222d8fce3?w=800&q=80"
  },
  tertiary: {
    title: "Tertiary Level Healthcare Facilities",
    description: "Advanced specialized medical care",
    facilities: [
      "Medical College & Hospitals",
      "Super-Specialty Hospitals",
      "Cancer Institutes",
      "Regional Referral Hospitals",
      "PG Institutes (up to 3600 Beds)"
    ],
    image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&q=80"
  },
  special: {
    title: "Special Category Hospitals",
    description: "Specialized medical institutions",
    facilities: [
      "Post Graduate Teaching Hospitals",
      "TB & Chest Hospitals",
      "Cardiology Hospitals",
      "Trauma Care Hospitals",
      "Transplant Hospitals",
      "Temporary Makeshift Hospitals (up to 2500 Beds)",
      "Temporary Makeshift ICU Hospital (up to 1000 Beds)"
    ]
  },
  government: {
    title: "Government Healthcare Institutions",
    facilities: [
      "ESIC Hospitals",
      "Railway Hospitals",
      "Defence / Armed Forces Hospitals",
      "BARC Hospital",
      "Port Trust Hospitals",
      "ESIS Hospitals",
      "Municipal Corporation Hospitals"
    ]
  }
};

export const coreStrengthsData = [
  {
    id: 1,
    title: "Single-Agency Accountability",
    description: "Complete responsibility from conceptualization to commissioning and long-term operations."
  },
  {
    id: 2,
    title: "Expert Professional Team",
    description: "Dedicated specialists with decades of proven experience across all levels of hospital facilities."
  },
  {
    id: 3,
    title: "Laboratory Infrastructure",
    description: "NBS Laboratory, BSL-2 and BSL-3 laboratory infrastructure capability for advanced medical research."
  },
  {
    id: 4,
    title: "Compliance Excellence",
    description: "Full compliance with national and international healthcare standards including NMC, NABH, ICMR, NFPA, ISO."
  },
  {
    id: 5,
    title: "End-to-End Operations",
    description: "Complete hospital operations with medical, paramedical, technical, administrative, and facility staffing."
  },
  {
    id: 6,
    title: "Scale & Capacity",
    description: "Capability to deliver projects from PHC to PG Institutes of up to 3600 beds and temporary facilities up to 2500 beds."
  }
];

export const certificationsData = [
  {
    category: "Medical Standards",
    certifications: ["NMC", "NABH", "ICMR", "IPHS", "NGHCT"]
  },
  {
    category: "Engineering & Safety",
    certifications: ["HTM", "NFPA", "NBC", "PESO", "ISO"]
  },
  {
    category: "Specialized Compliance",
    certifications: ["National Organ Transplant Society", "PMABIM"]
  }
];

export const executionModelData = [
  {
    step: 1,
    title: "Conceptual Planning & Feasibility",
    description: "Site analysis, ROI assessment, and Detailed Project Report (DPR) preparation."
  },
  {
    step: 2,
    title: "Design & Architecture",
    description: "Comprehensive design as per NMC, NABH, ICMR, HTM, NFPA, ISO, IPHS, NBC standards."
  },
  {
    step: 3,
    title: "Engineering, Procurement & Construction",
    description: "MEP and modular healthcare infrastructure including specialized medical facilities."
  },
  {
    step: 4,
    title: "Medical Equipment & IT Systems",
    description: "Planning and implementation of cutting-edge medical technology and information systems."
  },
  {
    step: 5,
    title: "Testing, Commissioning & Handover",
    description: "Comprehensive testing, validation, and handover with all statutory approvals."
  },
  {
    step: 6,
    title: "Hospital Operations & Management",
    description: "Complete staffing and patient report management system for long-term excellence."
  }
];

export const leadershipTeamData = [
  {
    id: 1,
    name: "Gulshan Bakhtiani",
    title: "Founder Director",
    image: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/k8vg7088_Gulshan%20Bakhtiani.jpg",
    bio: "A visionary entrepreneur with 30+ years of leadership experience in healthcare and pharmaceutical sector. He has played a pivotal role in shaping modern retail pharmacy, medical distribution, and specialized healthcare services in India.",
    expertise: "Business scaling, strategic planning, and hyper-local retail models integrating physical networks with digital fulfillment.",
    ventures: [
      "Wellness Forever Medicare Pvt. Ltd. – Co-founder",
      "Lilac Insights Pvt. Ltd. – Co-founder",
      "Pinnacle Biomed Pvt. Ltd. – Founder",
      "The Parel Chemist – Founder"
    ],
    education: "B.Sc. in Science (Physics), Jai Hind College, Mumbai"
  },
  {
    id: 2,
    name: "Mr. Mohan Chavan",
    title: "Founder-Director",
    image: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/g5jp9z4z_Mohan%20Chavan%20.JPG",
    bio: "Founder-Director and Whole-Time Director of Wellness Forever Medicare Ltd., with decades of experience in pharmaceutical manufacturing, marketing, and distribution. His leadership extends across Rahul Distributors Pvt. Ltd. and Pinnacle Biomed Pvt. Ltd.",
    expertise: "Pharma operations, product management, logistics, and building robust supply chains with scalable retail operations.",
    ventures: [
      "Wellness Forever Medicare Ltd. – Founder-Director",
      "Rahul Distributors Pvt. Ltd. – Founder-Director",
      "Pinnacle Biomed Pvt. Ltd. – Director"
    ],
    education: ""
  },
  {
    id: 3,
    name: "Mr. Amol Chavan",
    title: "Founder Director",
    image: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/4z8n2etr_Amol%20Chavan%2011.jpg",
    bio: "An accomplished healthcare entrepreneur and business leader with extensive experience in building and managing healthcare, medical technology, and allied infrastructure enterprises. With a strong foundation in corporate governance and healthcare business management, he has been actively involved in strategic leadership, operational growth, and organizational expansion.",
    expertise: "Strengthening healthcare delivery systems and advancing healthcare infrastructure through innovation, strategic planning, and decisive leadership. Core competencies in developing and executing turnkey healthcare projects, enabling healthcare institutions to enhance operational efficiency, clinical capability, and patient care outcomes.",
    ventures: [
      "Pinnacle Biomed Pvt. Ltd. – Founder Director",
      "4 other Ventures"
    ],
    education: ""
  }
];

export const managementTeamData = [
  {
    id: 1,
    name: "Mr. Dinesh Sawant",
    title: "Director Projects",
    image: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/9xnnbwhh_1%20Dinesh%20Sawant.jpg",
    bio: "A seasoned healthcare professional with 33 years of experience in projects and sales within medical infrastructure and hospital systems. Deep domain expertise across CVTS, Cardiology, Radiology, Pathology, Critical Care, and Anaesthesiology.",
    expertise: "Technical leadership, project execution, client engagement, and compliance with global safety standards.",
    certifications: [
      "Certified MGPS Specialist (HTM UK)",
      "NFPA MGPS Certified (USA)",
      "Authorised & Competent Person (HTM UK)"
    ]
  },
  {
    id: 2,
    name: "Mr. Ranjan Kalwai",
    title: "Division Head",
    image: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/vdvg1lu2_1%20Ranjan%20Kalwai.jpg",
    bio: "An accomplished healthcare professional with 36 years of experience in sales and service of medical equipment, specializing in Radiology systems. Deep technical and commercial expertise in managing high-value diagnostic equipment.",
    expertise: "Installation, commissioning, service support, client management, and lifecycle management of radiology equipment.",
    certifications: []
  },
  {
    id: 3,
    name: "Mr. Premanand P.P.",
    title: "General Manager",
    image: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/d44rksz0_image.png",
    bio: "A seasoned healthcare infrastructure professional with 32 years of experience across design, projects, and service operations in medical infrastructure systems. Strong technical and managerial expertise.",
    expertise: "Planning, execution, lifecycle management of healthcare facilities, safety, compliance, and risk-managed project delivery.",
    certifications: [
      "Postgraduate in Safety Engineering",
      "Authorised Person for MGPS (HTM UK)"
    ]
  }
];

export const contactData = {
  title: "Get in Touch",
  description: "Ready to discuss your healthcare infrastructure project? Contact our team for a consultation.",
  email: "info@pinnaclebiomed.in",
  phone: "+91 22 4579 6459",
  address: "3A & 3B, 3rd Floor, Trust House, 35 Hospital Avenue, Dr. E. Borges Road, Parel, Mumbai - 400012, India"
};

export const majorCustomersData = [
  {
    id: 1,
    name: "Maharashtra Medical Goods Procurement Authority",
    shortName: "MMGPA",
    type: "Government"
  },
  {
    id: 2,
    name: "Directorate of Health Services, Maharashtra",
    shortName: "DHS",
    type: "Government"
  },
  {
    id: 3,
    name: "HLL Lifecare Limited",
    shortName: "HLL",
    type: "PSU"
  },
  {
    id: 4,
    name: "Disaster Management Department, Government of Maharashtra",
    shortName: "DMD",
    type: "Government"
  },
  {
    id: 5,
    name: "State Public Health Laboratory, Maharashtra",
    shortName: "SPHL",
    type: "Government"
  },
  {
    id: 6,
    name: "Maharashtra Institute of Virology, Pune",
    shortName: "MIV",
    type: "Government"
  },
  {
    id: 7,
    name: "Navi Mumbai Municipal Corporation – Health Department",
    shortName: "NMMC",
    type: "Municipal"
  },
  {
    id: 8,
    name: "Municipal Corporation of Greater Mumbai – Health Department",
    shortName: "MCGM",
    type: "Municipal"
  },
  {
    id: 9,
    name: "Thane Municipal Corporation – Health Department",
    shortName: "TMC",
    type: "Municipal"
  },
  {
    id: 10,
    name: "Lilavati Hospital and Research Centre",
    shortName: "Lilavati",
    type: "Private"
  },
  {
    id: 11,
    name: "Railway Hospitals (Indian Railways Medical Services)",
    shortName: "Indian Railways",
    type: "Government"
  },
  {
    id: 12,
    name: "BARC Hospital (Bhabha Atomic Research Centre Hospital), Mumbai",
    shortName: "BARC",
    type: "Government"
  }
];

export const partnerCompaniesData = [
  { id: 1, name: "SIEMENS MEDICAL" },
  { id: 2, name: "DRAEGER" },
  { id: 3, name: "SYSMEX" },
  { id: 4, name: "SEBIA" },
  { id: 5, name: "LAB SYSTEMS" },
  { id: 6, name: "LEICA" },
  { id: 7, name: "TRIVITRON" },
  { id: 8, name: "SUTTER" },
  { id: 9, name: "OLYMPUS" },
  { id: 10, name: "KARL KAPS" },
  { id: 11, name: "KEELER" },
  { id: 12, name: "VOLK" },
  { id: 13, name: "ALLIED MEDICAL" },
  { id: 14, name: "APPASAMY" },
  { id: 15, name: "ALLENGERS" },
  { id: 16, name: "HARIOM" },
  { id: 17, name: "FUJI MEDICAL" },
  { id: 18, name: "THERMOFISHER" },
  { id: 19, name: "AGAPPE" },
  { id: 20, name: "BEACON DIAGNOSTICS" },
  { id: 21, name: "AGD DIAGNOSTICS" },
  { id: 22, name: "HOLOGIC" },
  { id: 23, name: "BIOMERIEUX" },
  { id: 24, name: "MOLBIO DIAGNOSTICS" },
  { id: 25, name: "MERIL DIAGNOSTICS" },
  { id: 26, name: "EPREDIA" },
  { id: 27, name: "BODYSTAT" },
  { id: 28, name: "DHPL" }
];

export const completedProjectsData = [
  { id: 1, product: "CT Scan 128 Slice", institution: "Govt Medical College Yavatmal", location: "Yavatmal", category: "Diagnostic" },
  { id: 2, product: "Medical Kit EERR", institution: "Disaster Management Maharashtra Government", location: "Maharashtra", category: "Emergency" },
  { id: 3, product: "Lab Equipment DHS", institution: "Maharashtra Medical Goods Procurement Authority", location: "Maharashtra", category: "Laboratory" },
  { id: 4, product: "Capillarys Sebia Hemoglobinopathy Analyzer", institution: "BARC Hospital", location: "Mumbai", category: "Diagnostic" },
  { id: 5, product: "Hysterectomy Set", institution: "Dr. V.M. GMC, Solapur", location: "Solapur", category: "Surgical" },
  { id: 6, product: "Gynac Medical Instrument", institution: "Civil Surgeon Washim", location: "Washim", category: "Surgical" },
  { id: 7, product: "New Born Screening System", institution: "NMMC", location: "Navi Mumbai", category: "Diagnostic" },
  { id: 8, product: "Modular PM Room", institution: "Civil Surgeon Ahilyanagar", location: "Ahilyanagar", category: "Infrastructure" },
  { id: 9, product: "Mammography Machine", institution: "Civil Surgeon Amravati", location: "Amravati", category: "Diagnostic" },
  { id: 10, product: "Instruments & Equipments", institution: "Civil Surgeon Washim", location: "Washim", category: "Surgical" },
  { id: 11, product: "Instruments & Equipments", institution: "Civil Surgeon Beed", location: "Beed", category: "Surgical" },
  { id: 12, product: "Instruments", institution: "GMC Miraj", location: "Miraj", category: "Surgical" },
  { id: 13, product: "4K Laparoscopic Unit with Accessories", institution: "GMC Miraj", location: "Miraj", category: "Surgical" },
  { id: 14, product: "4K Laparoscopic Unit with Accessories", institution: "PVP MC Sangli", location: "Sangli", category: "Surgical" },
  { id: 15, product: "Phacoemulsification Machine", institution: "Civil Surgeon Kolhapur", location: "Kolhapur", category: "Ophthalmology" },
  { id: 16, product: "Ultrasound Machine DHS", institution: "Maharashtra Medical Goods Procurement Authority", location: "Maharashtra", category: "Diagnostic" },
  { id: 17, product: "Hand Held X-Ray DHS", institution: "Maharashtra Medical Goods Procurement Authority", location: "Maharashtra", category: "Diagnostic" },
  { id: 18, product: "Modular Operation Theater", institution: "Navi Mumbai Municipal Corporation", location: "Navi Mumbai", category: "Infrastructure" },
  { id: 19, product: "PICU Modular Work", institution: "Ambejogai Medical College", location: "Ambejogai", category: "Infrastructure" },
  { id: 20, product: "PACU", institution: "Latur Medical College", location: "Latur", category: "Infrastructure" },
  { id: 21, product: "Modular Operation Theater", institution: "Akola Medical College", location: "Akola", category: "Infrastructure" },
  { id: 22, product: "Hand Instrument", institution: "Civil Hospital Akola", location: "Akola", category: "Surgical" },
  { id: 23, product: "Gynac Medical Instrument Equipment", institution: "Yavatmal Medical College", location: "Yavatmal", category: "Surgical" },
  { id: 24, product: "ENT Equipment", institution: "Yavatmal Medical College", location: "Yavatmal", category: "ENT" },
  { id: 25, product: "Medical Equipment", institution: "Thane Civil Hospital", location: "Thane", category: "General" },
  { id: 26, product: "Phaco Machine", institution: "Kolhapur Medical College", location: "Kolhapur", category: "Ophthalmology" },
  { id: 27, product: "DR Machine", institution: "Navi Mumbai Municipal Corporation", location: "Navi Mumbai", category: "Diagnostic" },
  { id: 28, product: "ILR Refrigerator DHS", institution: "Disaster Management Maharashtra Government NDRF", location: "Maharashtra", category: "Emergency" },
  { id: 29, product: "Medical Kit", institution: "Government NDRF", location: "Maharashtra", category: "Emergency" },
  { id: 30, product: "Ultrasound Machine DHS", institution: "Maharashtra Medical Goods Procurement Authority", location: "Maharashtra", category: "Diagnostic" }
];
